import React from 'react';
import PropTypes from 'prop-types';
import BookingActivitiesTable from './booking/Table';
import compose from 'recompose/compose';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchOrderBookingActivities } from 'store/actions/orderActivitiesActions';

const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 1px;
    min-height: 200px;
`;

class BookingActivities extends React.Component {
    componentDidMount() {
        const { data } = this.props;

        if (utils.isEmpty(data)) {
            this.fetchData();
        }
    }

    fetchData() {
        const { id } = this.props;

        this.props.fetchData({
            id: id,
        });
    }

    render() {
        const { data, translate } = this.props;

        if (utils.isEmpty(data)) {
            return <StyledWrapper>
                <p>{ translate('resources.orders.show.activities.booking.empty') }</p>
            </StyledWrapper>;
        }

        return (
            <div style={ { width: '100%' } }>
                <BookingActivitiesTable data={ data } />
            </div>
        );
    }
}

BookingActivities.propTypes = {
    data: PropTypes.array,
    fetchData: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const { id } = props.record;

    return {
        id: id,
        data: state.orderBookingActivities.data[id],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (payload) => {
            dispatch(fetchOrderBookingActivities(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(BookingActivities);



// WEBPACK FOOTER //
// ./src/pages/bookings/bookingActivities/BookingActivities.js